import React, { memo } from "react";

import StatusText from "../../typography/status";
import styled from "styled-components";

export const getStatusFromACOS = (
  acos: string | number,
  conditionalFormatting?: boolean
) =>
  conditionalFormatting === false
    ? "disabled"
    : acos
    ? acos === "-"
      ? "disabled"
      : Number(acos) <= 15
      ? "success"
      : Number(acos) <= 25
      ? "warning"
      : "error"
    : "disabled";

export const Cell = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
`;

interface ACOSCellProps {
  cell: {
    value: {
      value: number | string;
      conditionalFormatting?: boolean;
    };
  };
}

const ACOSCell = memo<ACOSCellProps>(function ACOSCell({ cell }) {
  const { value } = cell.value;
  const conditionalFormatting = cell.value.conditionalFormatting;

  const acos =
    typeof value === "string" && value.includes("%")
      ? parseFloat(value.replace("%", ""))
      : value;
  const status = getStatusFromACOS(acos, conditionalFormatting);

  return (
    <Cell>
      <StatusText
        align="right"
        variant="body2"
        status={conditionalFormatting === false ? undefined : status}
      >
        {value}
      </StatusText>
    </Cell>
  );
});

export default ACOSCell;
